module.exports = __webpack_public_path__ + "img/icon-delete-preto.0095e723.svg";